import { PourMethod } from './PourMethod'
import { OrderStatus } from './OrderStatus'

export interface Order<T = OrderDetail> {
  billToAccount: string,
  details: T,
  orderKey: string,
  summary: OrderSummary,
}

export type OrderWithoutDetails = Order<null>
// {
//   billToAccount: string,
//   details: null,
//   orderKey: string,
//   summary: OrderSummary,
// }

export interface OrderSummary {
  status: OrderStatus,
  startTime: string,
  orderCode: string,
  orderLine: string,
  title: string,
  subTitle: string,
  customerCode: string,
  // projectName: string,
}

export interface OrderDetail {
  cancelledAt: string,
  deliveryAddress: string,
  projectName: string,
  spacing: string,
  instructions: string,
  po: string,
  siteTel: string,
  siteContactName?: string | null,
  boralTel: string,
  pourMethod: PourMethod | null,
  pourMethodDescription?: string,
  plusLoad: boolean,
  plusLoadDetails: OrderDetailPlusLoad,
  lotNumber: null,
  truckSize: string,
  companyCode: string,
  testingRequired: boolean,
  slump: null | string,
  cdLink?: string,
  isModificationRestricted: boolean,
  isPendingModification: boolean,
  quantityAlreadyModified: boolean,
  tradingRegion: string,
  numberOfScheduledTrucks: number,
  qty: {
    ordered: number
    dispatched: number,
    uom: string,
  },
  product: {
    name: string,
    code: string,
  }[],
  modifyFields?: {},
}

type OrderDetailPlusLoadNotSubmitted = {
  status: PlusLoadStatus.NOT_SUBMITTED,
  qty: null,
}
type OrderDetailPlusLoadOtherThanNotSubmitted = {
  status: PlusLoadStatus.SUBMITTED | PlusLoadStatus.APPLIED | PlusLoadStatus.REJECTED,
  qty: number,
}
export type OrderDetailPlusLoad = OrderDetailPlusLoadNotSubmitted | OrderDetailPlusLoadOtherThanNotSubmitted

export enum PlusLoadStatus {
  NOT_SUBMITTED = 'NOT_SUBMITTED',
  SUBMITTED = 'SUBMITTED',
  APPLIED = 'APPLIED',
  REJECTED = 'REJECTED',
}

// usage: const { orderDate, orderId, orderLine } = getOrderIdTrio(order)
export function getOrderIdTrio(order: Order) {
  const orderDate = order.orderKey.slice(0, order.orderKey.indexOf('-'));
  const orderId = order.orderKey.slice(order.orderKey.indexOf('-') + 1, order.orderKey.lastIndexOf('-'));
  const orderLine = order.orderKey.slice(order.orderKey.lastIndexOf('-') + 1);
  return {
    orderDate,
    orderId,
    orderLine,
  }
}
